export const educationLevels = [
    { code: 'el', label: 'Elementary School'},
    { code: 'hg', label: 'High School' },
    { code: 'bd', label: "Bachelor's Degree" },
    { code: 'md', label: "Master's Degree" },
    { code: 'pd', label: 'Professional or Doctorate'},
];
